export default __webpack_public_path__ + "static/media/tick.57b18bae.svg";